<div class="btn-group" data-automation-id="f-dropdown-btn-group">
  <button
    data-automation-id="split-button"
    class="btn"
    [disabled]="disabled || loading"
    [ngClass]="[btnStyle, iconClass]"
    [attr.title]="dropdownButtonTitle"
    (click)="buttonClick.emit()"
  >
    @if (icon) {
    <i class="f-i" [ngClass]="icon"></i>
    }
    <span class="text-truncate">{{ text }}</span>
    @if (loading) {
    <f-spinner rootCssClass="spinner-center"></f-spinner>
    }
  </button>
  <div
    class="btn-group"
    ngbDropdown
    [container]="container"
    display="dynamic"
    [placement]="placement"
    (openChange)="onSplitToggleChange($event)"
    data-automation-id="f-dropdown-btn-container"
  >
    <button
      class="btn"
      [disabled]="disabled || loading"
      [ngClass]="[btnStyle, iconClass]"
      ngbDropdownToggle
      fDropdownListFocus
      [focusableItemsContainer]="dropdownMenu"
      [attr.title]="dropdownToggleTitle"
    >
      @if (isTopPlacement && isDropdownOpen) {
      <i class="f-i f-i-xs f-i-caret-down form-caret"></i>
      } @else if (isTopPlacement) {
      <i class="f-i f-i-xs f-i-caret-up form-caret"></i>
      } @else {
      <i class="f-i f-i-xs f-i-caret-down form-caret"></i>
      }
    </button>
    <div #dropdownMenu ngbDropdownMenu data-automation-id="f-dropdown-menu">
      <ng-content></ng-content>
    </div>
  </div>
</div>
